module.exports = __webpack_public_path__ + "img/1532602501.bc082726.jpg";